
import lightTheme from '@/utils/themes/default-light';
import darkTheme from '@/utils/themes/default-dark';
export default {
    lightTheme,
    darkTheme
}